import React, { useEffect, useState } from "react";

import {
  Text,
  Toast,
  Input,
  Picker,
  EditModal,
  ConfirmAlert,
  GroupInfoBox,
  AddItemButton,
  DeleteAlertComponent,
} from "components";

import { useFlag } from "hooks";
import { changeArrayAt, mq } from "utils";
import { colors, sizes, strings } from "assets/constants";

import { useCustomerSocialsTypes } from "clients/apis";
import { SocialsTypesIcons } from "assets/data";
import { View } from "react-native";
import css from "styles";

export default function Socials(props: {
  socials: SocialT[];
  onChange: (socials: SocialT[]) => void;
  disabled?: boolean;
}) {
  const { data: socialsTypes } = useCustomerSocialsTypes();

  const { socials, onChange, disabled } = props;
  const [itemsState, setItemsState] = useState<Array<SocialT>>(socials);
  useEffect(() => {
    setItemsState(socials);
  }, [socials]);

  const [indexToEdit, setIndexToEdit] = useState<number | null>(null);
  const { flg: modal, on: showModal, off: hideModal } = useFlag();
  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();

  const [fields, setFields] = useState<SocialT>();
  const updateFields = (newVal: SocialT) =>
    setFields((prev) => ({ ...prev, ...newVal }));

  const _onChangeType = (type?: TypeT) => updateFields({ type });
  const _onChangeAddress = (address: string) => updateFields({ address });

  const resetForm = () => {
    setIndexToEdit(null);
    setFields({});
  };

  const _onAdd = () => {
    fields && onChange(socials ? [...socials, fields] : [fields]);
    resetForm();
  };

  const _onEdit = () => {
    const tmp =
      typeof indexToEdit === "number" &&
      changeArrayAt(itemsState, indexToEdit, fields);
    tmp && onChange(tmp);
  };

  const _onDelete = (close: () => void) => {
    const tmp =
      typeof indexToEdit === "number" && changeArrayAt(itemsState, indexToEdit);
    tmp && onChange(tmp);
    resetForm();
    close();
  };

  const _onConfirm = () => {
    if (!fields?.type || !fields.address) {
      Toast.error({ message: strings.fill_all_fields });
      return;
    }
    indexToEdit === null ? _onAdd() : _onEdit();
    resetForm();
    hideModal();
  };

  const _onCancel = () => {
    resetForm();
    hideModal();
  };

  return (
    <>
      <View style={css.responsiveListContainer}>
        {itemsState?.length > 0 ? (
          itemsState?.map((social: SocialT, key: number) => {
            return (
              <View key={String(key)} style={css.responsiveBoxContainer}>
                <GroupInfoBox
                  disabled={disabled}
                  key={String(key)}
                  onEdit={() => {
                    setIndexToEdit(key);
                    setFields(social);
                    showModal();
                  }}
                  onDelete={() => {
                    setIndexToEdit(key);
                    showAlert();
                  }}
                  title={social?.type?.title}
                  icon={{
                    name: social?.type?.id
                      ? SocialsTypesIcons?.[social?.type?.id]
                      : "link",
                  }}
                  renderContent={() => (
                    <>
                      <Text style={{ lineHeight: 22 }}>{social.address}</Text>
                    </>
                  )}
                />
              </View>
            );
          })
        ) : (
          <Text
            size="sm"
            color={colors.textColorGray}
            style={{ marginBottom: sizes.space / 2 }}
          >
            {strings.no_customer_social}
          </Text>
        )}
      </View>

      {!disabled && (
        <AddItemButton onPress={showModal} title={strings.add_new_social} />
      )}

      <EditModal
        visible={modal}
        onCancel={_onCancel}
        onConfirm={_onConfirm}
        renderForm={() => {
          return (
            <>
              {socialsTypes?.data && (
                <Picker
                  onSelect={_onChangeType}
                  data={socialsTypes?.data}
                  value={fields?.type?.title}
                  placeholder={strings.pick_social_type}
                  icon={{ name: "airplay" }}
                />
              )}

              <Input
                onChangeText={_onChangeAddress}
                value={fields?.address}
                placeholder={strings.insert_social_address}
                icon={{ name: "link" }}
              />
            </>
          );
        }}
      />

      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <DeleteAlertComponent
            removeLoading={false}
            remove={() => _onDelete(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
